import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Styles from "./ProgramMain.module.scss";
import ButtonWithLink from "../buttons/ButtonWithLink";
import { useState, useEffect } from "react";
import AOS from "aos";
import GetInTouch from "../common_components/forms/GetInTouch";

export default function ProgramMain({ bookMySpot, handleSucess, handleError, buttonId, filteredData }) {
  // let navigate = useNavigate();
  const { programName } = useParams();
  const { letsConnect } = useParams();
  const [getInTouchOpen, setGetInTouchOpen] = useState(letsConnect ? letsConnect : false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    if (location.search.includes('zohoFormSubmitted=true')) {
      handleDownloadPDF();

      const newUrl = location.pathname;
      navigate(newUrl, { replace: true });
    }
  }, [location, navigate]);

  const newProgramName = programName.split("_").join(" ");

  const handleSucessToasterGIT = (messageGIT) => {
    handleSucess(messageGIT);
  };
  const handleErrorToasterGIT = (messageGIT) => {
    handleError(messageGIT);
  };

  // const handleDownloadPDF = () => {
  //   const link = document.createElement('a');
  //   link.href = 'https://d1ixtxt2uzttul.cloudfront.net/Documents/100BoardMembers -Frameworkoverview.pdf';
  //   link.download = '100BM.pdf';
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const handleDownloadPDF = () => {
    fetch('https://cms.iamironlady.com/wp-content/uploads/2024/09/Iron-Lady-100-Board-Members-Program.pdf', {
      mode: 'no-cors'
    })
      .then(() => {
        const link = document.createElement('a');
        link.href = 'https://cms.iamironlady.com/wp-content/uploads/2024/09/Iron-Lady-100-Board-Members-Program.pdf';
        link.download = 'Iron Lady 100 Board Members Program.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => console.error('Error downloading the PDF:', error));
  };

  return (
    <>
      {getInTouchOpen && (
        <GetInTouch
          isDemo={false}
          isRegister={true}
          isWorkProfile={true}
          isSeeYourSelf={true}
          isExp={true}
          setDialogOpen={setGetInTouchOpen}
          open={getInTouchOpen}
          programName={newProgramName}
          sucessToasterGIT={handleSucessToasterGIT}
          errorToasterGIT={handleErrorToasterGIT}
        />
      )}

      <div className={Styles["program"]}>
        <div className={Styles["program_main"]}>
          <span
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            className={Styles["program_name"]}
          >
            {filteredData?.title?.replace(/_/g, ' ')}
          </span>
          <div className={Styles["program_video"]}>
            <div>
              <video
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
                className={Styles["programImage"]}
                controls
                poster={filteredData?.programMain?.videoThumbneil}
              >
                <source
                  src={filteredData?.programMain?.videoLink}
                  type="video/mp4"
                />
              </video>
            </div>
            <div className={Styles["program_content"]}>
              <div className={Styles["program-question"]}>
                <span
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-easing="ease-in-out"
                  className={Styles["content"]}
                  style={{ marginBottom: '16px' }}
                >
                  {
                    window.location.pathname === "/individualPrograms/100_Board_Members_Program" ? (filteredData?.programMain?.question1?.split(" ").map((word, wordIndex) => {
                      if (wordIndex === 4 || wordIndex === 5 || wordIndex === 6 || wordIndex === 8 || wordIndex === 13 || wordIndex === 14) {
                        return (
                          <span style={{ fontWeight: "bold", color: '#F52929' }} key={wordIndex}>
                            {" "}
                            {word}
                          </span>
                        );
                      } else {
                        return <span key={wordIndex}> {word}</span>;
                      }
                    })) : (filteredData?.programMain?.question1)
                  }

                </span>
                <span
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-easing="ease-in-out"
                  className={Styles["content"]}
                >
                  {" "}
                  {filteredData?.programMain?.question2}
                </span>
                <span
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-easing="ease-in-out"
                  className={Styles["content"]}
                >
                  {" "}
                  {filteredData?.programMain?.question3}
                </span>
              </div>
              <p
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
                className={Styles["content"]}
              >
                {
                  window.location.pathname === "/individualPrograms/100_Board_Members_Program" ? (
                    filteredData?.programMain?.content2?.split(" ").map((word, wordIndex) => {
                      if (wordIndex === 3 || wordIndex === 4 || wordIndex === 5 || wordIndex === 6 || wordIndex === 16 || wordIndex === 17 || wordIndex === 18) {
                        return (
                          <span style={{ fontWeight: "bold", color: '#F52929' }} key={wordIndex}>
                            {" "}
                            {word}
                          </span>
                        );
                      } else {
                        return <span key={wordIndex}> {word}</span>;
                      }
                    })
                  ) : window.location.pathname === "/individualPrograms/Leadership_Essentials_Program" ? (
                    filteredData?.programMain?.content2?.split(" ").map((word, wordIndex) => {
                      if (wordIndex === 6 || wordIndex === 7) {
                        return (
                          <span style={{ fontWeight: "bold", color: '#F52929' }} key={wordIndex}>
                            {" "}
                            {word}
                          </span>
                        );
                      } else {
                        return <span key={wordIndex}> {word}</span>;
                      }
                    })
                  ) : window.location.pathname === "/individualPrograms/hindi/Leadership_Essentials_Program" ? (
                    filteredData?.programMain?.content2?.split(" ").map((word, wordIndex) => {
                      if (wordIndex === 14) {
                        return (
                          <span style={{ fontWeight: "bold", color: '#F52929' }} key={wordIndex}>
                            {" "}
                            {word}
                          </span>
                        );
                      } else {
                        return <span key={wordIndex}> {word}</span>;
                      }
                    })
                  ) : (
                    <span> {filteredData?.programMain?.content2}</span>
                  )
                }
              </p>


              <p
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
                className={Styles["content-last"]}
              >
                {" "}
                {filteredData?.programMain?.content3}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
        {window.location.pathname === "/individualPrograms/Leadership_Essentials_Program" ? (
          <div className={Styles[bookMySpot === false ? "book_spot" : "bottom-book_spot"]}>
            <div onClick={() => window.open("https://zfrmz.in/CtpKGZVXAsbN9iNaE1LW", "_blank")}>
              <ButtonWithLink
                id={buttonId}
                name="Apply for the Program"
                className={"button-width-red"}
              />
            </div>
          </div>
        ) : window.location.pathname === "/individualPrograms/hindi/Leadership_Essentials_Program" ? (
          <div className={Styles[bookMySpot === false ? "book_spot" : "bottom-book_spot"]}>
            <div onClick={() => window.open("https://zfrmz.in/CtpKGZVXAsbN9iNaE1LW", "_blank")}>
              <ButtonWithLink
                id={buttonId}
                name="आवेदन करें"
                className={"button-width-red"}
              />
            </div>
          </div>
        ) : window.location.pathname === "/individualPrograms/100_Board_Members_Program" ? (
          <div className={Styles[bookMySpot === false ? "book_spot" : "bottom-book_spot"]}>

            <div onClick={() => window.location.href = 'https://zfrmz.in/V6zZplvb6g9iMnSY3Ex3'}>
              <ButtonWithLink
                id={buttonId}
                name="Download Brochure"
                className={"button-width-red"}
              />
            </div>
          </div>
        ) : (
          <div className={Styles[bookMySpot === false ? "book_spot" : "bottom-book_spot"]}>
            {/* <div onClick={() => setGetInTouchOpen(true)}> */}
            <div onClick={() => window.location.href = 'https://zfrmz.in/boZr9Cru7BVFkZsqt5dV'}>
              <ButtonWithLink
                id={buttonId}
                name="Apply for the Program"
                className={"button-width-red"}
              />
            </div>
          </div>
        )}
      </div>

    </>
  );
}

// temorarily removed

// <div onClick={() => setGetInTouchOpen(true)}>
//               <ButtonWithLink
//                 id={buttonId}
//                 name="Apply for the Program"
//                 className={"button-width-red"}
//               />
//             </div>